/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import VisibilitySensor from 'react-visibility-sensor';

import LayersAlt from './img/icons/LayersAlt';
import PencilRuler from './img/icons/PencilRuler';
import Diamond from './img/icons/Diamond';
import RightArrow from './img/icons/RightArrow';
import IconOne from './img/icons/IconOne';
import IconTwo from './img/icons/IconTwo';
import IconThree from './img/icons/IconThree';
import { Container, Row, Col } from 'reactstrap';

class Features extends React.Component {
  render() {
    const {
      styles: s,
    } = this.props;
    return (
      <div id="feature">
        <section className={cx(s.fizIconBoxArea, s.fIconBoxAreaTwo)}>
          <Container>
            <Row>
              <Col md="4" xs="12" className={cx(s.fizIconBox, s.fizIconBoxTwo)}>
                <VisibilitySensor
                  intervalDelay={0}
                  partialVisibility
                >
                  {({ isVisible }) => (
                    <div className={cx(s.animatedIcon, s.colored)}>
                      {
                        isVisible &&
                        <IconOne />
                      }
                    </div>
                  )}
                </VisibilitySensor>
                <div className={s.fizIconText}>
                  <h4>360-degree skills benchmarking</h4>
                  <p>Success profiles are created for all organizational roles – using insights from the industry and internal data on jobs and performance. Against which you can evaluate employees, create succession plans, create career pathways, maintain a skill inventory, identify mission critical skills <br /><br /></p>
                  {/* <a href="#"><i className={s.arrowRight}></i></a>
                  <a href="#"><RightArrow /></a> */}
                </div>
              </Col>
              <Col md="4" xs="12" className={cx(s.fizIconBox, s.fizIconBoxTwo)}>
                <VisibilitySensor
                  intervalDelay={0}
                  partialVisibility
                >
                  {({ isVisible }) => (
                    <div className={cx(s.animatedIcon, s.colored)}>
                      {
                        isVisible &&
                        <IconThree />
                      }
                    </div>
                  )}
                </VisibilitySensor>
                <div className={s.fizIconText}>
                  <h4>Hyper-personalised learning pathway</h4>
                  <p>Content sources -both internal as well as external are scanned to automatically create indexed catalogs. These are dynamic learning content catalogs, accompanied with a content authoring tool to incorporate new content in real time. Various AI techniques are then used to create most relevant and personalised learning plans for individual users. </p>
                  {/* <a href="#"><i className={s.arrowRight}></i></a>
                  <a href="#"><RightArrow /></a> */}
                </div>
              </Col>
              <Col md="4" xs="12" className={cx(s.fizIconBox, s.fizIconBoxTwo)}>
                <VisibilitySensor
                  intervalDelay={0}
                  partialVisibility
                >
                  {({ isVisible }) => (
                    <div className={cx(s.animatedIcon, s.colored)}>
                      {
                        isVisible &&
                        <IconTwo />
                      }
                    </div>
                  )}
                </VisibilitySensor>
                <div className={s.fizIconText}>
                  <h4>Quantification of learning outcomes</h4>
                  <p>Connections between business impact, performance metrics and upskilling and learning interventions are established using sophisticated statistical analysis techniques. Performance metrics can be tracked through various internal systems in real time to deliver the effectiveness of learning program and identify their contribution to business outcomes. </p>
                  {/* <a href="#"><i className={s.arrowRight}></i></a>
                  <a href="#"><RightArrow /></a> */}
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    );
  }
}

export default Features;



// WEBPACK FOOTER //
// ./src/routes/home/Features.js